import React, {useMemo} from "react"
import {makeStyles} from "@material-ui/core/styles"
import FormGroup from "@material-ui/core/FormGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Switch from "@material-ui/core/Switch"
import {useDispatch, useStore} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import clsx from "clsx"

const useStyles = makeStyles(() => ({
  root: {
    display: `inline`,
    width: `100%`,
    marginTop: `8px`,
    zIndex: (props) => (props.zIndex === `forwardOption` ? 1201 : 0),
  },
}))

export default function ForwardOption() {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const {
    store: {perspective, locale, forwardOption, zIndex},
  } = useStore()
  const classes = useStyles({
    zIndex,
  })
  const handleChange = (event) => {
    forwardOption[perspective] = event.target.checked
    dispatch({
      type: `FORWARD_OPTION`,
      forwardOption,
    })
  }
  return useMemo(
    () => (
      <FormGroup row>
        <FormControlLabel
          className={clsx(classes.root, `forwardOption`)}
          control={<Switch checked={forwardOption[perspective]} onChange={handleChange} value="forwardOption" />}
          label={forwardOption[perspective] ? t(`forwardOptionOff`) : t(`forwardOptionOn`)}
        />
      </FormGroup>
    ),
    [classes, locale, perspective, forwardOption[perspective]],
  )
}
